import { Link } from "react-router-dom";
import { useClient } from "../../../../Context/ClientContext";

export const SalesDropdownItems: any = () => {
  const { currentClient } = useClient();
  return [
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/sales/addInvoice`}>
          Sales Invoice
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <Link
          to={`/books/clients/${currentClient?.id}/sales/addProformaInvoice`}
        >
          Proforma Invoice
        </Link>
      ),
      key: "5",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/sales/addCreditNote`}>
          Credit Note
        </Link>
      ),
      key: "1",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/sales/addReceipt`}>
          Receipt
        </Link>
      ),
      key: "2",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/sales/addEstimate`}>
          Estimate
        </Link>
      ),
      key: "3",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/sales/addOrder`}>
          Sales Order
        </Link>
      ),
      key: "4",
    },
  ];
};

export const PurchaseDropdownItems: any = () => {
  const { currentClient } = useClient();
  return [
    {
      label: (
        <Link
          to={`/books/clients/${currentClient?.id}/purchase/addPurchaseBill`}
        >
          Purchase Invoice
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/purchase/addDebitNote`}>
          Debit Notes
        </Link>
      ),
      key: "1",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/purchase/addPaymentOut`}>
          Payment
        </Link>
      ),
      key: "2",
    },

    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/purchase/addOrder`}>
          Purchase Order
        </Link>
      ),
      key: "3",
    },
  ];
};

export const ExpenseIncomeDropdownItems: any = () => {
  const { currentClient } = useClient();
  return [
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/expenses/addExpenses`}>
          Expense
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/income/addIncome`}>
          Income
        </Link>
      ),
      key: "1",
    },
  ];
};

export const AssetDropdownItems: any = () => {
  const { currentClient } = useClient();
  return [
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/asset/addFixedAsset`}>
          Asset
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <Link to={`/books/clients/${currentClient?.id}/asset/addDisposed`}>
          Disposed
        </Link>
      ),
      key: "1",
    },
  ];
};
